import axios, { AxiosResponse } from 'axios';
import EnvWindow from '../../../utils/env';
import { IFaqListResponse } from './supportFaq.types';

const faqUrl = `${EnvWindow.REACT_APP_SUPPORT_API_URL}/Faq`;

export async function getFaqList() : Promise<AxiosResponse<IFaqListResponse>> {
  return await axios.get(`${faqUrl}/list`);
}

export async function createFaq(question: string, answer: string): Promise<AxiosResponse> {
  return await axios.post(faqUrl, {
    question: question,
    answer: answer,
  });
}

export const deleteFaq = async (faqId: string): Promise<AxiosResponse<boolean>> => {
  return await axios.delete(faqUrl, { data: { id: faqId }});
};

export async function updateFaq(id: string, newQuestion: string, newAnswer: string): Promise<AxiosResponse> {
  return await axios.put(faqUrl, {
    id,
    question: newQuestion,
    answer: newAnswer,
  });
}
